import { IApp, NewAppPayload } from "@API/Apps/types";
import { createAction } from "@reduxjs/toolkit";

export const appsListRequest = createAction<void>("APPS_LIST/REQUEST");
export const appsListSuccess = createAction<IApp[]>("APPS_LIST/SUCCESS");
export const appsListFail = createAction<Error>("APPS_LIST/FAIL");

export const createAppRequest = createAction<NewAppPayload>("CREATE_APP/REQUEST");
export const createAppSuccess = createAction<IApp>("CREATE_APP/SUCCESS");
export const createAppFail = createAction<Error>("CREATE_APP/FAIL");

export const setModalCreateApp = createAction<void>("SET_MODAL_CREATE_APP");
export const resetCreateAppModal = createAction<void>("MODAL_CREATE_APP_RESET");

export interface AppPolicyData {
  appId: string;
  type: string;
  contentEN: string;
  contentDE: string;
}

export const getAppPolicyRequest = createAction<{
  appId: string;
  type: string;
}>("GET_APP_POLICY/REQUEST");
export const getAppPolicySuccess = createAction<AppPolicyData>(
  "GET_APP_POLICY/SUCCESS"
);
export const getAppPolicyFail = createAction<Error>("GET_APP_POLICY/FAIL");

export const addAppPolicy = createAction<{
  appId: string;
  type: string;
  contentEN: string;
  contentDE: string;
}>("ADD_APP_POLICY/REQUEST");
export const addAppPolicySuccess = createAction("ADD_APP_POLICY/SUCCESS");
export const addAppPolicyFail = createAction("ADD_APP_POLICY/FAIL");
